import * as React from 'react';
import * as styles from './styles.scss';
import { AssetRegistryProvider } from '../hooks/useAssetRegistry';
import {
    getAnnouncement,
    getSelectedProjectId,
    getPoliteAnnouncement,
    getIsCanvasLockedFromLocalStorage,
    getIsAssetsLockedFromLocalStorage,
} from 'owa-timestream-store';
import { observer } from 'mobx-react-lite';
import { ProjectIdProvider, ViewStateSelectorsProvider } from 'owa-timestream-asset-sdk';
import { setCanvasLock, setAssetsLock } from 'owa-timestream-asset-sdk-actions';
import type { TimeStreamCanvasProps } from '../schema';
import TimeStreamCanvasBodyAndPanel from './TimeStreamCanvasBodyAndPanel';
import { viewStateSelectors } from '../viewstate';

export default observer(function TimeStreamCanvas({ assetRegistry }: TimeStreamCanvasProps) {
    const projectId = getSelectedProjectId();

    React.useEffect(() => {
        setCanvasLock(getIsCanvasLockedFromLocalStorage(projectId));
        setAssetsLock(getIsAssetsLockedFromLocalStorage(projectId));
    }, [projectId]);

    return (
        <AssetRegistryProvider value={assetRegistry}>
            <ProjectIdProvider value={projectId}>
                <ViewStateSelectorsProvider value={viewStateSelectors}>
                    <div key={projectId} className={styles.timeStreamCanvas}>
                        <span className="screenReaderOnly" aria-live="assertive" aria-atomic="true">
                            {getAnnouncement()}
                        </span>
                        <span className="screenReaderOnly" aria-live="polite" aria-atomic="true">
                            {getPoliteAnnouncement()}
                        </span>
                        <TimeStreamCanvasBodyAndPanel />
                    </div>
                </ViewStateSelectorsProvider>
            </ProjectIdProvider>
        </AssetRegistryProvider>
    );
});
